<template>
  <div class="pic-page">
    <img :src="pic" />
    <div class="back-btn">
      <van-icon name="arrow-left" size="0.7rem"  @click="onBack"/>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, toRef } from 'vue'
import { useRoute } from 'vue-router'

export default {
  setup() {
    const route = useRoute()
    const data = reactive({
      pic: ''
    })

    onMounted(() => {
      const { pic, title } = route.query
      data.pic = pic
      document.title = title
    })

    const onBack = () => {
      window.history.back()
    }

    return {
      pic: toRef(data, 'pic'),
      onBack
    }
  }
}
</script>

<style lang="less" scoped>
.pic-page {
  min-height: 100vh;
  img {
    width: 100%;
  }
  .back-btn {
    position: fixed;
    top: 20px;
    left: 20px;
    z-index: 100;
    width: 40px;
    height: 40px;
    line-height: 36px;
    text-align: center;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    border-radius: 50%;
    font-size: 30px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    &:active {
      box-shadow: 0 0 10px rgba(0, 0, 0, 0);
    }
  }
}
</style>